import React, { useEffect, useState } from "react";
import { clientIds, customLinkData, customMenuUISettings, responsiveSettings } from "../../../../config/clients/clients";
import DropDown from "../../../../component/dropdown/dropdown";
import TemplateOneFragment from "../clientsMenu/TemplateOneFragment";
import Image from "../../../../component/image/Image";
import chevronOrange from "../../../../assets/images/clients/chevron-orange.svg";
import useClientConfig from "../../../../config/careers/clientConfig";

const OptionThreeMegaMenu = (props: any) => {

    const { menuSettings, clientId } = props;
    const [navOpen, setNavOpen] = useState<boolean>(false);
    const [dropdownIcon, setDropdownIcon] = useState<boolean>(false);
    const [doesMenuActAsAccordion, setMenuActAsAccordion] = useState(false);
    const [disableMainLink, setDisableMainLink] = useState(false);
    const responsiveBreakPoint = 991;
    const {clientSiteSettings, clientMenuSettings} = useClientConfig();
    const templateName = clientSiteSettings?.templateName;
    
    const [linkListData, setLinkListData] = useState<any>({
        id : "",
        linkList : []
    });

    useEffect(() => { 
        if (clientMenuSettings) {
            setLinkListData(clientMenuSettings);
        }
    }, [customLinkData, menuSettings]);

    console.log("clientMenuSettings", clientMenuSettings);

    useEffect(() => {
        if (responsiveBreakPoint && screen.width < responsiveBreakPoint) {
            setDisableMainLink(true);
        }
    }, []);

    

    const toggleLinkListData = (currentId:any, toggle:boolean, doesMenuActAsAccordion?: boolean) => {
        setLinkListData((listItems:any) => {
            let modifiedList = listItems.linkList;
            let currentItemIndex = modifiedList.findIndex((item: { id: any; }) => item.id === currentId);
            console.log("currentItemIndexcurrentItemIndex", currentItemIndex);
            if(doesMenuActAsAccordion && doesMenuActAsAccordion === true){
                if(modifiedList[currentItemIndex]["open"]){
                    modifiedList[currentItemIndex]["open"] = false;
                } else {
                    modifiedList[currentItemIndex]["open"] = true;
                }
            } 
            else if (modifiedList[currentItemIndex]) {
                modifiedList = modifiedList.map((item: any, index: number) => 
                    index === currentItemIndex ? { ...item, open: toggle } : item
                );
            }
    
            return {
                ...listItems,
                linkList : modifiedList
            };
          });
    };

    useEffect(() => {
        if (responsiveSettings.vyMenuBreakpoint && screen.width < responsiveSettings.vyMenuBreakpoint) {
            setMenuActAsAccordion(true);
        }
    }, []);

    //Mouse enter to toggle dropdown, acts as touch during mobile responsive
    const onMouseEnter = (currentId:any) => {
        toggleLinkListData(currentId, true, doesMenuActAsAccordion);
    };

    const onMouseLeave = (currentId:any) => {
        toggleLinkListData(currentId, false);
    };

    const toggleNavBar = () => {
        navOpen ? setNavOpen(false) : setNavOpen(true);

        if(navOpen) {
            document.body.classList.remove("menu-open-body");
        } else {
            document.body.classList.add("menu-open-body");
        }
    };

    return (
        <> 
            <header>
                <div className={navOpen ? "header header-menu-open" : "header header-menu-closed"}>
                    <div className="container-new">
                        
                        <div className="head-parent">
                            <div className="head-left">
                                <div className="logo-new">
                                    <a href={menuSettings.homeLinkHref} rel="noreferrer" target="_blank">
                                        <img src={process.env.PUBLIC_URL + menuSettings.logoimg} className="cust-logo-desktop-img"/>
                                        <img src={process.env.PUBLIC_URL + menuSettings.moblogoimg}  className="cust-logo-mob-img" />
                                    </a>
                                </div>
                            </div>
                            <button className={navOpen ? "responsive-nav-btn menu-open" : "responsive-nav-btn menu-closed"} onClick={toggleNavBar}>
                                <img className="menu-open-icon" src={process.env.PUBLIC_URL + menuSettings.menuToggle}/>
                                <img className="menu-close-icon" src={process.env.PUBLIC_URL + menuSettings.menuToggleClose}/></button>
                            <div className="head-right">
                                {
                                    (templateName === "template_10") ? (
                                        <div className="head_top_menu">
                                            <ul>
                                                <li>
                                                    <a href="https://www.holmesglen.edu.au/study-with-us/international-student-study">INTERNATIONAL</a>
                                                </li>
                                                <li>
                                                    <a href="https://www.holmesglen.edu.au/current-students">CURRENT STUDENTS</a>
                                                </li>
                                                <li>
                                                    <a href="https://www.holmesglen.edu.au/about-us/contact-us">CONTACT</a>
                                                </li>
                                                <li>
                                                    <a href="#" onClick={(e) => {
                                                        e.preventDefault();
                                                        const subMenu = e.currentTarget.nextElementSibling;
                                                        const subMenuParent = e.currentTarget;
                                                        if (subMenu) {
                                                            subMenu.classList.toggle("show_submenu");
                                                            subMenuParent.classList.toggle("show_submenu_parent");
                                                        }
                                                    }}>LOGIN <span className="cmp-button__icon icon-nav-arrow-down" aria-hidden="true"></span></a>
                                                    <ul className="sub_menu_toggle">
                                                        <li><a href="https://my.holmesglen.edu.au/PROD/twbkwbis.P_GenMenu?name=homepage&_gl=1*1lw2zc2*_gcl_au*MTAxMjQ1NTg5LjE3MzA4ODY2OTA.&_ga=2.155274109.756617606.1730886691-132097702.1730886691">Student Portal</a></li>
                                                        <li><a href="https://portal.office.com/">Student Email</a></li>
                                                        <li><a href="https://holmesglen.sirsidynix.net.au/uhtbin/cgisirsi/0/0/0/29/0/REVIEW_MY_ACCOUNT/1">Library Login</a></li>
                                                        <li><a href="https://holmesglen.brightspace.com/">Brightspace</a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        
                                        </div>
                                    ) : "" 
                                }
                                
                                <nav className={navOpen ? "nav-open" : "nav-closed"}>
                                    <ul className="submenu-list">
                                        {linkListData?.linkList.map((listItem:any) => {
                                            return (
                                                <li 
                                                    key={listItem.href}
                                                    onMouseEnter={() => onMouseEnter(listItem.id)}
                                                    onMouseLeave={() => onMouseLeave(listItem.id)}
                                                    className={listItem.open ? "open test" : ""}
                                                >
                                                    <a href={(disableMainLink) ? "#" : listItem.href} title={listItem.name} rel="noreferrer" target={(disableMainLink) ? "_self" : "_blank"} > {listItem.name} {listItem.open}</a>  
                                                    <span className="menu-arrow-new cmp-button__icon icon-nav-arrow-down"  onClick={() => onMouseEnter(listItem.id)}>{ dropdownIcon ? <Image src={chevronOrange} /> : "" }</span>
                                                    {
                                                        (listItem.customMenuTemplate && listItem.customMenuTemplate === true) ? 
                                                            <TemplateOneFragment menuSettings={menuSettings} submenuItems={listItem.submenu}/>
                                                        : 
                                                        <DropDown submenuItems={listItem.submenu} menuType={listItem.subType} menuSettings={menuSettings}/>
                                                    }
                                                    
                                                </li>
                                            );
                                        })}

                                        {
                                            (templateName === "template_10") ? (
                                            <li>
                                                <a href="#"><span className="icon-search"></span></a>
                                            </li>  
                                            ) : ""
                                        }
                                        
                                        {
                                            (templateName === "template_1") ? (
                                            <li>
                                                <a href="#"><span className="icon-search"></span></a>
                                            </li>  
                                            ) : ""
                                        }
                                    </ul>
                                    
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};


export default OptionThreeMegaMenu;